import { set } from 'lodash/fp';

import { ActiveFewShotDocument, ActiveMLDocument, ActiveMLDocumentType, ActiveMLOpinion, AmendmentExtensiveProgress, ExtensiveProgress, FewShotDocumentProgress, InitialProgress, OpinionProgress, TestMLDocument } from '../auth/notifications/store/types';

export const initialProgressSteps = Object.values(InitialProgress).filter(progressString => typeof progressString === 'number') as number[];
export const extensiveProgressSteps = Object.values(ExtensiveProgress).filter(progressString => typeof progressString === 'number') as number[];
export const amendmentExtensiveProgressSteps = Object.values(AmendmentExtensiveProgress).filter(progressString => typeof progressString === 'number') as number[];
export const opinionProgressSteps = Object.values(OpinionProgress).filter(progressString => typeof progressString === 'number') as number[];

export const initialProgressWording = {
    [InitialProgress.FAILED]: 'Something went wrong',
    [InitialProgress.DOCUMENT_UPLOADED]: 'OCR\'ing document...',
    [InitialProgress.TEXTRACT_OCR_DOCUMENT_COMPLETE_AI]: 'Classifying document with AI...',
    [InitialProgress.TEXTRACT_OCR_DOCUMENT_COMPLETE]: 'Finalising document upload...',
    [InitialProgress.INITIAL_CLASSIFICATION_COMPLETE]: 'Cross referencing LEI Database...',
    [InitialProgress.CROSS_REFERENCING_LEI_DATABASE_COMPLETE]: 'Finalising document upload...',
    [InitialProgress.INITIAL_DOCUMENT_PROCESSING_COMPLETE]: 'Initial document upload complete'
};

export const extensiveProgressWording = {
    [ExtensiveProgress.FAILED]: 'Something went wrong',
    [ExtensiveProgress.QUERIES_AND_INSTANCE_COLLECTED]: 'Querying document...',
    [ExtensiveProgress.EXTENSIVE_QUERIES_RECEIVED]: 'Post processing results...',
    [ExtensiveProgress.ECS_TABLE_EXTRACTION_COMPLETE]: 'Extracting ECS table...',
    [ExtensiveProgress.ANNEX_TABLE_EXTRACTION_COMPLETE]: 'Post processing results...',
    [ExtensiveProgress.PARTIAL_POST_PROCESSING_COMPLETE]: 'Post processing results...',
    [ExtensiveProgress.FURTHER_POST_PROCESSING_COMPLETE]: 'Populating Ark51 datamap...',
    [ExtensiveProgress.ALL_POST_PROCESSING_COMPLETE]: 'Extensive data extraction complete'
};

export const amendmentProgressWording = {
    [AmendmentExtensiveProgress.FAILED]: 'Something went wrong',
    [AmendmentExtensiveProgress.QUERIES_AND_INSTANCE_COLLECTED]: 'Determining suitable queries...',
    [AmendmentExtensiveProgress.EXTENSIVE_QUERIES_RECEIVED]: 'Extracting available queries...',
    [AmendmentExtensiveProgress.ALL_POST_PROCESSING_COMPLETE]: 'Suggested queries found'
};

export const opinionProgressWording = {
    [OpinionProgress.FAILED]: 'Something went wrong',
    [OpinionProgress.TEXTRACT_STARTED]: 'OCR\'ing opinion...',
    [OpinionProgress.TEXTRACT_COMPLETE]: 'Querying opinion...',
    [OpinionProgress.EXTENSIVE_QUERIES_RECEIVED]: 'Data extracted with AI...',
    [OpinionProgress.ADDITIONAL_DATA_EXTRACTED]: 'Populating Ark51 datamap...',
    [OpinionProgress.NO_EXTRACTION_TEXTRACT_COMPLETE]: 'OCR Process Complete',
    [OpinionProgress.ALL_POST_PROCESSING_COMPLETE]: 'Opinion data extraction complete'
};

export const fewShotDocumentProgressWording = {
    [FewShotDocumentProgress.FAILED]: 'Something went wrong',
    [FewShotDocumentProgress.DOCUMENT_UPLOADED]: 'OCR\'ing document...',
    [FewShotDocumentProgress.TEXTRACT_OCR_DOCUMENT_COMPLETE]: 'Querying document...',
    [FewShotDocumentProgress.DOCUMENT_PROCESSING_COMPLETE]: 'Data extraction complete'
};

export const setProgressString = (activeMLDocument: ActiveMLDocument) => {
    let progressString = initialProgressWording[activeMLDocument.progress as InitialProgress];
    switch (activeMLDocument.activeMLDocumentType) {
        case ActiveMLDocumentType.EXTENSIVE_EXTRACTION:
            progressString = extensiveProgressWording[activeMLDocument.progress as ExtensiveProgress];
            break;
        case ActiveMLDocumentType.AMENDMENT_QUERY_EXTRACTION:
            progressString = amendmentProgressWording[activeMLDocument.progress as AmendmentExtensiveProgress];
            break;
        default:
            break;
    }
    return set('progressString', progressString, activeMLDocument);
};

export const setTestDocumentProgressString = (testMLDocument: TestMLDocument) => set('progressString', initialProgressWording[testMLDocument.progress as InitialProgress], testMLDocument);

export const setOpinionProgressString = (activeMLOpinion: ActiveMLOpinion) => set('progressString', opinionProgressWording[activeMLOpinion.progress as OpinionProgress], activeMLOpinion);

export const setFewShotProgressString = (activeFewShotDocument: ActiveFewShotDocument) => set('progressString', fewShotDocumentProgressWording[activeFewShotDocument.progress as FewShotDocumentProgress], activeFewShotDocument);
